import { request } from "."

export const trackersApi = {
  getAll() {
    return request("/api/trackers")
  },
  create(formData: FormData) {
    return request("/api/trackers", formData)
  },
  edit(trackerId: string, formData: FormData) {
    return request("/api/trackers/"+trackerId, formData)
  }
}